export default "__VITE_ASSET__DoW8usvg__"